import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { isAuthenticated } from "../auth";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Box, Button} from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle';

import { getUserBalance } from './walletApi'
import BalanceCard from "./component/balanceCard"
import Transactions from "./component/transactions"
import Layout from "../core/Layout";

//import Sidebar from "./component/sidebar"


const useStyles = makeStyles((theme) => {
   
    return{
        account:{
            marginBottom: 40,
            color: "#37517E"
        },
        button: {
            marginTop: 15,
            color: "#fff",
            background: '#2ead4b',
            '&:hover': {
              background: '#069939',
            },
          },
        toolbar:{
            marginTop: 30
        }
    }
  });

 

function WalletDashBoard(){
    const {user, token } = isAuthenticated()
    const classes = useStyles()
    const [balance, setBalance] = useState();
    const cardNames = [
                        {id:1, name: "Peso", path:"/ph.png"}, 
                        {id: 2, name: "Star Points", path:"/star.png"}
                      ]
      
    useEffect(() =>{
        getUserBalance(user._id, token).then((data =[]) =>{
            if (data && data.error) {
                console.log(data.error) 
            } else {
             setBalance(data.netAmount)
            }
          })
    },[])
    
    return(
        <Layout>
            <div  style={{ paddingTop: 150 }}></div>
            <div className="container">
                <Box>
                    <Typography variant="h4" className={classes.account}> Account </Typography>
                    <Box md={12}>
                        <Grid container spacing={3}> 
                            {
                                cardNames.map((cardName) =>(
                                    <Grid item key={cardName.id} md={4}>
                                        <BalanceCard 
                                            name={cardName.name}
                                            path={cardName.path}
                                            balance={balance}
                                        />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Box>
                    <Box>
                        <Link to="/user/wallet/top-up" className="nav-link">
                            <Button 
                             variant="contained" 
                             className={classes.button} 
                             disableElevation
                             endIcon={<AddCircleIcon/>}
                             >
                                Top Up
                            </Button>
                        </Link>
                    </Box>
                    <hr/>
                    <Box md={12}>
                    <Transactions />
                    </Box>
                </Box>
            </ div>
        </Layout>
    )
}

export default WalletDashBoard;